import { Extension } from "@tiptap/core";
import { paragraphAttributes, emptyParagraphAttributes, characterAttributes } from "../styles/style-store";

const HEADING_LEVELS = { h1: 1, h2: 2, h3: 3 };
const CHARACTER_KEYS = ["charStyle", "fontFamily", "fontSize", "color", "fontWeight", "fontStyle", "textTransform"];

// Aplica os estilos do painel: de paragrafo (troca o tipo do bloco e grava
// a formatacao em linha) e de trecho (marca textStyle).
export const DocumentStyles = Extension.create({
    name: "documentStyles",

    addCommands() {
        return {
            applyParagraphStyle: (style) => ({ chain, editor }) => {
                const run = chain();
                if (style.element === "blockquote") {
                    if (!editor.isActive("blockquote")) run.setParagraph().setBlockquote();
                    return run.updateAttributes("paragraph", emptyParagraphAttributes()).run();
                }
                if (editor.isActive("blockquote")) run.unsetBlockquote();
                const level = HEADING_LEVELS[style.element];
                if (level) run.setHeading({ level });
                else run.setParagraph();
                return run.updateAttributes(level ? "heading" : "paragraph", paragraphAttributes(style)).run();
            },
            applyCharacterStyle: (style) => ({ chain }) => chain().setMark("textStyle", characterAttributes(style)).run(),
            clearCharacterStyle: () => ({ chain }) => {
                const empty = {};
                CHARACTER_KEYS.forEach((key) => { empty[key] = null; });
                return chain().setMark("textStyle", empty).removeEmptyTextStyle().run();
            },
        };
    },
});

// Estilo de paragrafo do bloco onde esta o cursor (documentos antigos nao
// tem data-style: deduz pelo tipo do bloco).
export function currentParagraphStyleKey(editor) {
    if (editor.isActive("blockquote")) return "citacao";
    const block = editor.state.selection.$from.parent;
    if (block.attrs.dataStyle) return block.attrs.dataStyle;
    if (block.type.name === "heading") return `titulo-${block.attrs.level}`;
    return "texto-normal";
}

export function currentCharacterStyleKey(editor) {
    return editor.getAttributes("textStyle").charStyle || null;
}
